<div class="container-fluid">
  <div class="row mb-4">
    <div class="fw-bold fs-27 col-md-6 col-12 mt-2">
      Students List
      <div class="border-green-bottom"></div>
    </div>

    <div class="col-md-6 col-12 mt-2 d-flex justify-content-md-end gap-3">
      <div class="mt-2">
        <!-- <button class="btn btn-primary" (click)="triggerFileUpload()">Import Excel</button> -->
        <div
          [innerHTML]="SVG_ICONS.IMPORT_EXCEL_ICON() | sanitizer : 'html'"
          (click)="triggerFileUpload()"
          class="cursor-pointer"
          matTooltip="Import Excel"
          matTooltipPosition="below"
          matTooltipShowDelay="0"></div>
        <input type="file" id="fileUpload" (change)="onFileSelected($event)" accept=".xlsx, .xls" style="display: none" />
      </div>
      <div class="search-area">
        <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="position-absolute mt-2 ms-2"></div>
        <input type="text" class="search-input" placeholder="Search Student" (keyup)="applyFilter($event)" />
      </div>
    </div>
  </div>
  <div class="table-responsive-scroll">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" class="w-100" matSort>
        <!-- Member Name Column -->
        <ng-container matColumnDef="FirstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Student Name</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">
            <div class="d-flex align-items-center gap-2">
              <div class="profile-image-container border-radius-50 overflow-hidden d-flex align-items-center justify-content-center bg-white">
                <img [src]="getProfileImageUrl(student.ProfileDocuments)" alt="Profile" class="w-100 h-100 object-fit-cover" />
              </div>
              <div class="d-flex flex-column">
                <span class="fw-bold font-white cursor-pointer" (click)="onActionClick(student.StudentID)">{{ student.FirstName }} {{ student.MiddleName || "" }} {{ student.LastName }}</span>
                <span class="fs-12 font-white">
                  <a href="tel: +91 {{ student.MobileNo || '-' }}" class="font-white fs-12 fw-normal text-decoration-none">+91 {{ student.MobileNo }}</a>
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Email</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">{{ student.Email || "-" }}</td>
        </ng-container>

        <!-- Age -->
        <ng-container matColumnDef="DOB">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Age</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">{{ calculateAge(student.DOB) || "-" }}</td>
        </ng-container>
        <!-- <ng-container matColumnDef="DOB">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Age</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">{{ student.DOB | date : "dd/MM/yyyy" }}</td>
        </ng-container> -->

        <!-- Height -->
        <ng-container matColumnDef="height">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Height (cm)</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">{{ student.Height || "-" }}</td>
        </ng-container>

        <!-- Weight -->
        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Weight (kg)</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">{{ student.Weight || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="BeltName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Belt Name</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">
            <div class="fw-bold d-flex justify-content-center border-radius-10 p-2 fs-14" [style.backgroundColor]="student.belt?.BeltColor" [style.color]="getBeltTextColor(student.belt?.BeltColor)">
              {{ student.belt?.BeltName || "-" }}
            </div>
          </td>
        </ng-container>

        <!-- Batch -->
        <!-- <ng-container matColumnDef="batch">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Batch</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">
            <ng-container *ngIf="getActiveClass(student) as activeClass">
              {{ activeClass.StartTime | date:'h:mm' }} - {{ activeClass.EndTime | date:'h:mm a' }}
            </ng-container>
            <ng-container *ngIf="!getActiveClass(student)">
              -
            </ng-container>
          </td>
        </ng-container> -->

        <ng-container matColumnDef="CenterName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-bold font-gray p-3">Center</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">
            <div class="fw-bold d-flex justify-content-center border-radius-10 p-2 fs-14 font-white bg-card-secondary">
              {{ student.center?.CenterName || "-" }}
            </div>
          </td>
        </ng-container>

        <!-- Membership -->
        <ng-container matColumnDef="membership">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-gray">Membership Status</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">
            <span class="membership-pill">
              {{ getActivePackage(student)?.PackageName || "-" }}
            </span>
          </td>
        </ng-container>

        <!-- Attendance -->
        <!-- <ng-container matColumnDef="attendance">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Last Attended</th>
          <td mat-cell *matCellDef="let student" class="font-white p-3">
            <div class="d-flex align-items-center">
              <ng-container *ngFor="let icon of getAttendanceIcons(student.Last3DaysAttendance || '[]')">
                <div [innerHtml]="(icon === 'PRESENT_ATTENDENCE_ICON' ? SVG_ICONS.PRESENT_ATTENDENCE_ICON() : SVG_ICONS.ABSENT_ATTENDENCE_ICON()) | sanitizer : 'html'"></div>
              </ng-container>
            </div>
          </td>
        </ng-container> -->

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Action</th>

          <td mat-cell *matCellDef="let student" class="font-white p-3">
            <div
              class="cursor-pointer ms-4"
              matTooltip="View student details"
              matTooltipPosition="below"
              matTooltipShowDelay="0"
              tabindex="0"
              role="button"
              [innerHTML]="SVG_ICONS.DESC_ICON() | sanitizer : 'html'"
              (click)="onActionClick(student.StudentID)"
              (keydown.enter)="onActionClick(student.StudentID)"
              (keydown.space)="onActionClick(student.StudentID)"></div>
          </td>
        </ng-container>

        <!-- Header & Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <!-- Pagination -->
      <mat-paginator [pageSizeOptions]="[10, 20, 200]" [length]="Pagelength" showFirstLastButtons class="mt-3"></mat-paginator>
    </div>
  </div>
</div>

@if(dataSource.data.length === 0){
<div class="text-center font-red-light fs-20 mt-4">No Data Found</div>
}
